import { MESApiService, type spParameter } from "@dexteel/mesf-core";

export const getDelayCodes = async (delayAreaAssetId: number | null) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "DelayAreaAssetId", value: delayAreaAssetId },
  ];

  return await apiService.callV2("[DEL].[GetDelayCodes]", parameters);
};
